export default {"src":"/_next/static/media/orange_crown.0763213b.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};